module.exports = __webpack_public_path__ + "img/empty-notification.49cfc02b.svg";